import React from 'react';
import { Heart, Users, Sparkles } from 'lucide-react';

export const About = () => {
  return (
    <section
      id="about"
      className="py-24 px-4 sm:px-6 lg:px-8 relative border-t border-subtle"
      data-testid="about-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="eyebrow eyebrow-blue" data-testid="about-eyebrow">
            About LAB21G
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold mt-4 mb-4 text-strong tracking-tight"
            data-testid="about-heading"
          >
            Built by <span className="text-gradient-brand">FAMILY.</span>
          </h2>
          <p className="text-base text-muted max-w-2xl mx-auto" data-testid="about-subhead">
            The story behind LAB21G — who we are, why we started, and how we
            can help.
          </p>
        </div>

        <div className="card-surface p-7 sm:p-10 space-y-5 text-default leading-relaxed text-[15px] sm:text-base">
          <p>
            My name is <strong className="text-strong">TJ Stovall</strong>, and
            I run an Oklahoma-based sports card and memorabilia business with
            my family. Together, we do sports card breaks, card shows, live
            selling, and much more. Around here, "family business" really{' '}
            <em className="text-strong not-italic font-semibold">means</em>{' '}
            family business. It's me, my two sons{' '}
            <strong className="text-strong">Nathan</strong> and{' '}
            <strong className="text-strong">Samuel</strong>, my beautiful daughter{' '}
            <strong className="text-strong">Shelby</strong>, and the real boss
            of the operation — my beautiful wife,{' '}
            <span className="accent-green font-semibold">Amanda</span>.
          </p>

          <p>
            Outside of the sports card world, I work full-time in IT, and
            Amanda is a nurse with experience in the medical and IT space.{' '}
            <strong className="text-strong">Nathan</strong> is training to
            become a commercial pilot — something he has always aspired to be.{' '}
            <strong className="text-strong">Shelby</strong> is in college
            working toward her dream of becoming an Occupational Therapist.{' '}
            <strong className="text-strong">Samuel</strong> is still in high
            school as of the 2026/27 school year, on track to graduate in
            2028.
          </p>

          <p>
            <strong className="text-strong">Nathan</strong> runs the sports
            card business with me, while Amanda and Shelby keep the logistics
            and inventory side of things running smoothly. Samuel has been my
            right-hand on everything LAB21G — from building tools and systems
            to designing widgets — as we look for new ways to help other
            sellers and creators.
          </p>

          <p>
            After multiple years as TikTok sellers and now as eBay LIVE
            sellers, we've learned a lot about what it takes to sell online,
            manage live streams, stay organized, and create a better
            experience for customers. LAB21G was created so we could share
            those skills and help others who are getting started or looking
            to grow.
          </p>

          <div className="my-7 grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="about-pillars">
            <div className="card-surface p-4 text-center">
              <Users className="w-5 h-5 accent-green mx-auto mb-2" />
              <div className="text-sm font-semibold text-strong mb-1">Live Sellers & Breakers</div>
              <div className="text-xs text-muted">Widgets, team owner boards, scrollers, spot boards.</div>
            </div>
            <div className="card-surface p-4 text-center">
              <Sparkles className="w-5 h-5 accent-cyan mx-auto mb-2" />
              <div className="text-sm font-semibold text-strong mb-1">Excel & Data</div>
              <div className="text-xs text-muted">Formulas, forms, VBA, tracking, reporting, automation.</div>
            </div>
            <div className="card-surface p-4 text-center">
              <Heart className="w-5 h-5 accent-green mx-auto mb-2" />
              <div className="text-sm font-semibold text-strong mb-1">Small Business Sites</div>
              <div className="text-xs text-muted">Affordable, clean websites without overcomplicating things.</div>
            </div>
          </div>

          <p>
            At the heart of LAB21G is a simple goal: take the knowledge and
            skills we've built over the years and use them to help others{' '}
            <strong className="text-strong">save time, stay organized, and
            grow with confidence.</strong>
          </p>

          <p>
            Whether you're new to live selling, running card breaks, managing
            inventory, building a brand, or just trying to make your workflow
            a little smoother — we'd love to help.
          </p>

          <div className="pt-5 border-t border-subtle text-center">
            <p className="text-sm text-muted mb-2">Thanks from the Stovall Family,</p>
            <p className="text-lg sm:text-xl font-bold tracking-tight">
              <span className="text-gradient-brand">#StartSomethingLegendary</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
